// ----------------------------
// Created by Bulletproof Games
//            2017
//  www.bulletproofgames.co.uk
// ----------------------------
//
// Volume Button

hbcVolumeButton = {};

hbcVolumeButton.create = function () {
  var button = new PIXI.Container();

  InputHelpers.addGenerics(button);
  button._flags.muted = false;

  button.canEnable = function () {
    if (!this._flags.modal.active) {
      let popUpsOpen = false;
      let autoplay = resourceManager.get("autoplayContainer:autoplayBacker");
      if (autoplay.visible) popUpsOpen = true;

      let buyBonusPopUp = resourceManager.get("buyABonusContainer:buyBonusPopup");
      if (buyBonusPopUp.visible) popUpsOpen = true;

      if (popUpsOpen) messageBus.post('game:modal', { reason: 'popups are open' });
    }
    return soundManager.soundAvailable();
  };

  button.showButton = function () {
    if (this.canShow() && this.buttons !== undefined) {
      if (button._flags.muted) {
        switch (layoutController.getCurrentLayout()) {
          case "landscape_default": {
            this.button.buttonSprite.texture = this.buttons.textures[1];
            break;
          }
          case "landscape_mobile":
          case "portrait_default":
          case "portrait_mobile": {
            this.button.buttonSprite.texture = this.buttonsPortrait.textures[1];
            break;
          }
        }
      } else {
        switch (layoutController.getCurrentLayout()) {
          case "landscape_default": {
            this.button.buttonSprite.texture = this.buttons.textures[0];
            break;
          }
          case "landscape_mobile":
          case "portrait_default":
          case "portrait_mobile": {
            this.button.buttonSprite.texture = this.buttonsPortrait.textures[0];
            break;
          }
        }
      }
      this.button.visible = true;
    } else {
      this.hideButton();
    }
  };

  button.onPressedCallback = function () {
    const muted = !this._flags.muted;
    messageBus.postImmediate("audio:stateChanged", {
      type: "audio:stateChanged",
      muted,
    });
    this._flags.muted = muted;
  };

  button.onCurrentMuteState = function (state) {
    this._flags.muted = state.muted;
  };

  button.onGameConfigEvent = function () {
    this.buttons = textureParser.textureLists["volumeButtons"];
    this.buttonsPortrait = textureParser.textureLists["volumeButtonsPortrait"];
  };

  messageBus.subscribe(
    "spinner:GameConfigEvent",
    button.onGameConfigEvent.bind(button)
  );
  messageBus.subscribe(
    "audio:currentMuteState",
    button.onCurrentMuteState.bind(button)
  );

  return button;
};

hbcVolumeButton.initialise = function (json, object) {};

hbcVolumeButton.getFilesRequired = function () {
  return [
    ...textureParser.getFilesRequired("volumeButtons"),
    ...textureParser.getFilesRequired("volumeButtonsPortrait"),
  ];
};

resourceManager.registerObjectType(
  "hbcVolumeButton",
  hbcVolumeButton.create,
  hbcVolumeButton.initialise,
  hbcVolumeButton.getFilesRequired
);
